export const daysMap: { [key: string]: string } = {
	MONDAY: 'L',
	TUESDAY: 'M',
	WEDNESDAY: 'Mi',
	THURSDAY: 'J',
	FRIDAY: 'V',
	SATURDAY: 'S',
	SUNDAY: 'D',
};
